import {List, ListSubheader} from '@mui/material'
import {memo, type PropsWithChildren, type ReactNode} from 'react'

interface Props extends PropsWithChildren<any> {
  title?: ReactNode
}

export const NavGroup = memo(({title, children}: Props) => {
  return <List
    subheader={title && <ListSubheader component="div" className="ellipsis">
      {title}
    </ListSubheader>}
  >
    {children}
  </List>
})
